module.exports = __webpack_public_path__ + "static/media/laptop.00adaa76.png";